import React, { Component } from "react";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import {
  Button,
  AppBar,
  IconButton,
  Typography,
  Toolbar,
  Snackbar,
  Menu,
  MenuItem,
  Divider,
  CssBaseline,
  Badge,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Avatar,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";
import { withStyles } from "@material-ui/core/styles";
import * as PropTypes from "prop-types";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import clsx from "clsx";
import logoSvg from "./img/logo.svg";
import UserMenu from "./components/user_menu";
import ModuleContainer from "./pages/module_container";
import {
  AUTH_API_URL,
  getUserRoleByToken,
  MISC_API_URL,
  subscribeToNotifications,
} from "./lib/env";
import { messaging } from "./init-fcm";
import Home from "./pages/home";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Profile from "./pages/profile";
import { parseJwt } from "./lib/util";
import moment from "moment";
import "./sass/main.sass";
import CalendarPage from "./pages/calendar";
import Utp from "./components/utp";
import Messages from "./pages/messages";
import TextField from "@material-ui/core/TextField";

const drawerWidth = 300;
const mobileWidth = 500;

const styles = (theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `100%`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    zIndex: 200,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: window.outerWidth < mobileWidth ? 0 : theme.spacing(9) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
  },
});

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: localStorage.getItem("token"),
      isDrawerOpen: false,
      user: null,
      documentTitle: "Xcars",
      isNotificationSnackbarOpen: false,
      anchorEl: null,
      isOnline: true,
      isNoInternetSnackbarOpen: false,
      isInternetSnackbarOpen: false,
      unreadMessagesCount: 0,
      hbdDialogVisible: false,
    };

    this.pricerFrameRef = React.createRef();
    this.valuationFrameRef = React.createRef();
    this.crminalistFrameRef = React.createRef();
    this.inspectorFrameRef = React.createRef();
    this.finbrokerFrameRef = React.createRef();
    this.pppFrameRef = React.createRef();
    this.ppFrameRef = React.createRef();
    this.mmFrameRef = React.createRef();
    this.filterFrameRef = React.createRef();
    this.authFrameRef = React.createRef();
    this.calFrameRef = React.createRef();
    this.reportFrameRef = React.createRef();
    this.buyerFrameRef = React.createRef();
    this.npsFrameRef = React.createRef();
    this.carFrameRef = React.createRef();
    this.clientFrameRef = React.createRef();
    this.valuationOssRef = React.createRef();
    this.welcomeFrameRef = React.createRef();
    this.salesFrameRef = React.createRef();
    this.keysFrameRef = React.createRef();
    this.veditorFrameRef = React.createRef();
    this.dashboardFrameRef = React.createRef();
    this.ccFrameRef = React.createRef();
    this.docsFrameRef = React.createRef();
    this.xxxFrameRef = React.createRef();
    this.xxxBIRef = React.createRef();
    this.valuationLogistRef = React.createRef();
    this.contractsFrameRef = React.createRef();
    this.wikiFrameRef = React.createRef();
    this.seoFrameRef = React.createRef();
    this.sadminFrameRef = React.createRef();
    this.wwwLadaAdminFrameRef = React.createRef();
    this.hyperSalesFrameRef = React.createRef();
    this.orionUserAdminFrameRef = React.createRef();
    this.newCarSalesFrameRef = React.createRef();
    this.branchFrameRef = React.createRef();
    this.eduJournalFrameRef = React.createRef();
    this.guaranteeJournalFrameRef = React.createRef();
    this.qrFrameRef = React.createRef();
    this.carPricingFrameRef = React.createRef();
    this.bipiumxFrameRef = React.createRef();
    this.bipiumxCqFrameRef = React.createRef();
    this.limitsFrameRef = React.createRef();
    this.supportFrameRef = React.createRef();
    this.cpPayFrameRef = React.createRef();
    this.reportAppFormsFrameRef = React.createRef();
    this.csContractsFrameRef = React.createRef();
    this.arabaxFrameRef = React.createRef();
    this.newsFrameRef = React.createRef();
    this.staffListFrameRef = React.createRef();
    this.customerSupportFrameRef = React.createRef();
    this.bindingFrameRef = React.createRef();
    this.c2cFrameRef = React.createRef();
    this.newAutoAdminFrameRef = React.createRef();
    this.renewedCsFrameRef = React.createRef();
    this.tiresFrameRef = React.createRef();
    this.securityQrFrameRef = React.createRef();
    this.creditFlowFrameRef = React.createRef();
    this.signDocsFrameRef = React.createRef();
    this.collectionFrameRef = React.createRef();
    this.cessionFrameRef = React.createRef();

    this.hideDrawer = this.hideDrawer.bind(this);
  }

  hideDrawer() {
    this.setState({ isDrawerOpen: false });
  }

  handleIframeTask = (e) => {
    //console.log(e.origin);
    //console.log(e.data);
    // if (e.origin === 'http://localhost:3001') {
    //   alert(e.data)
    // }
  };

  subscribeToNotifications() {
    if (messaging === null) {
      return;
    }

    this.setState({ isNotificationSnackbarOpen: false });

    let self = this;
    getUserRoleByToken(this.state.token)
      .then((res) => {
        self.setState({ user: res.data });

        let isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );
        if (!isSafari) {
          Notification.requestPermission()
            .then((permission) => {
              console.log(permission);
              if (permission === "granted") {
                messaging.getToken().then((fcm_token) => {
                  console.log(fcm_token);
                  localStorage.setItem("fcm_token", fcm_token);
                  subscribeToNotifications(self.state.token, fcm_token)
                    .then((res) => {
                      console.log(res);
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                });
              }
            })
            .catch(function (err) {
              console.log("ERROR: Unable to get permission to notify.");
              console.log(err);
            });
        }

        navigator.serviceWorker.addEventListener("message", (message) => {
          console.log("msg received:");
          console.log(message);
        });
      })
      .catch((err) => {
        self.props.history.push("/signin");
      });
  }

  getUser(token) {
    let self = this;
    axios
      .get(AUTH_API_URL + "/users/getUserByToken", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function (response) {
        self.setState({ user: response.data });
        console.log("USER");
        console.log(response.data);
        self.showHbdDialog(response.data);
      })
      .catch(function (error) {
        console.log(error.message);
        if (error.message.includes("401") || error.message.includes("403")) {
          self.props.history.push("/signin");
        }
      });
  }

  showHbdDialog(user) {
    if (user === null || user.birthDate === null) {
      return;
    }

    let birthDate = moment(user.birthDate, "DD.MM.YYYY");
    let today = moment(new Date());

    if (
      today.date() === birthDate.date() &&
      today.month() === birthDate.month() &&
      localStorage.getItem("hbdSeen") !== "yes"
    ) {
      this.setState({
        hbdDialogVisible: true,
      });
    }
  }

  handleMessageFromIframe = (e) => {
    if (e.data === "refresh me") {
      console.log(e);
      window.location.reload();
    }
  };

  componentDidMount() {
    let self = this;
    window.addEventListener("message", this.messageReceiver);

    // if no token in localStorage get the fuck out!
    if (localStorage.getItem("token") === null) {
      this.props.history.push("/signin");
      return;
    }

    // if token expired get the fuck out!
    if (
      moment(new Date(parseJwt(this.state.token).exp * 1000)).isBefore(moment())
    ) {
      this.props.history.push("/signin");
      return;
    }

    // Add event listener offline to detect network loss.
    window.addEventListener("offline", function (e) {
      self.setState({ isOnline: false, isNoInternetSnackbarOpen: true });
    });

    // Add event listener online to detect network recovery.
    window.addEventListener("online", function (e) {
      self.setState({ isOnline: true, isInternetSnackbarOpen: true });
    });

    this.getUser(localStorage.getItem("token"));

    // this.getUnreadMessagesCount();

    if (messaging === null) {
      return;
    }

    // Get Instance ID token. Initially this makes a network call, once retrieved
    // subsequent calls to getToken will return from cache.
    messaging
      .getToken()
      .then((currentToken) => {
        console.log(currentToken);
        if (currentToken === null) {
          if (localStorage.getItem("blockNotifications") !== "1") {
            this.setState({ isNotificationSnackbarOpen: true });
          }
        }
        localStorage.setItem("fcm_token", currentToken);
        subscribeToNotifications(self.state.token, currentToken)
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });

    messaging.onTokenRefresh(() => {
      messaging
        .getToken()
        .then((refreshedToken) => {
          console.log("Token refreshed.");
          subscribeToNotifications(self.state.token, refreshedToken)
            .then((res) => {
              console.log(res);
              localStorage.setItem("fcm_token", refreshedToken);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log("Unable to retrieve refreshed token ", err);
        });
    });
  }

  updateTitle(title) {
    let prefix = "";
    window.location.hostname.includes("test") ||
    window.location.hostname.includes("localhost")
      ? (prefix = "TEST ")
      : (prefix = "");
    this.setState({ documentTitle: prefix + title });
    document.title = prefix + title;
    this.checkPasswordChange();
  }

  checkPasswordChange(e) {
    if (!localStorage.getItem("token")) {
      return;
    }

    if (Date.now() >= localStorage.getItem("token").exp * 1000) {
      return;
    }

    let self = this;
    axios
      .get(
        AUTH_API_URL +
          "/users/lastPasswordChange/" +
          parseJwt(localStorage.getItem("token")).sub,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
          },
        }
      )
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error.message);
        if (error.message.includes("400")) {
          alert("Необходимо обновить пароль!");
          self.props.history.push("/profile", {
            changePassword: true,
          });
        }
      });
  }

  openDrawer() {
    this.setState({ isDrawerOpen: true });
  }

  openProfileMenu = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  navProfile() {
    this.setState({ anchorEl: null });
    this.props.history.push("/profile");
  }

  signOut() {
    this.setState({ anchorEl: null });
    localStorage.removeItem("token");
    localStorage.removeItem("blockNotifications");
    this.props.history.push("/signin");
    localStorage.removeItem("hbdSeen");

    // console.log(this.valuationFrameRef);
    //
    // if (this.valuationFrameRef.current !== null) {
    //   this.valuationFrameRef.contentWindow.postMessage('logout', '*');
    //   console.log('logout sent');
    // } else {
    //   this.props.history.push('/signin');
    // }
  }

  messageReceiver = (e) => {
    if (
      (e.origin.includes("localhost") || e.origin.includes("xcars.kz")) &&
      !e.data.payload &&
      !e.data.source
    ) {
      console.log(e.data);
      if (e.data.includes("logout")) {
        localStorage.removeItem("token");
        this.props.history.push("/signin");
      } else if (e.data.includes("token$")) {
        localStorage.setItem("token", e.data.split("$")[1]);
      }
    }
  };

  openNotifications() {
    this.props.history.push("/messages");
  }

  getUnreadMessagesCount() {
    let self = this;
    axios
      .get(MISC_API_URL + "/message/getUnreadMessagesCount", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        console.log(response.data);
        self.setState({
          unreadMessagesCount: response.data,
        });
      })
      .catch(function (error) {
        console.log(error.message);
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {/*<Utp />*/}
        <CssBaseline />
        <AppBar
          position="fixed"
          style={
            this.state.isOnline
              ? { backgroundColor: "#333" }
              : { backgroundColor: "#ff0540" }
          }
          className={clsx(classes.appBar, {
            [classes.appBarShift]: this.state.isDrawerOpen,
          })}
        >
          <Avatar
            alt={""}
            src={
              "https://www.freepnglogos.com/uploads/christmas-lights-png/christmas-lights-png-download-29.png"
            }
            style={{
              borderRadius: 0,
              width: "100%",
              height: 120,
              position: "absolute",
              top: -50,
              left: 0,
              zIndex: 0,
            }}
          />

          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => this.setState({ isDrawerOpen: true })}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: this.state.isDrawerOpen,
              })}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" style={{ flexGrow: "1" }}>
              {this.state.documentTitle}
            </Typography>
            <div>
              <IconButton
                aria-label="notifications"
                aria-controls="menu-appbar"
                onClick={this.openNotifications.bind(this)}
                color="inherit"
              >
                {
                  <Badge
                    badgeContent={this.state.unreadMessagesCount}
                    color="secondary"
                  >
                    <NotificationsActiveIcon color="#FF4545" />
                  </Badge>
                }
              </IconButton>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={this.openProfileMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={this.state.anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(this.state.anchorEl)}
                onClose={() => this.setState({ anchorEl: null })}
              >
                <MenuItem onClick={this.navProfile.bind(this)}>
                  Профиль
                </MenuItem>
                <MenuItem onClick={this.signOut.bind(this)}>Выход</MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: this.state.isDrawerOpen,
            [classes.drawerClose]: !this.state.isDrawerOpen,
          })}
          classes={{
            paper: clsx("scrolls", {
              [classes.drawerOpen]: this.state.isDrawerOpen,
              [classes.drawerClose]: !this.state.isDrawerOpen,
            }),
          }}
          open={this.state.isDrawerOpen}
        >
          <div className={classes.toolbar}>
            <object
              style={{
                marginTop: "5px",
                marginBottom: "5px",
              }}
              type="image/svg+xml"
              data={logoSvg}
              aria-label="logo"
              height="35"
              border="0"
            />
            <IconButton onClick={() => this.setState({ isDrawerOpen: false })}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          {this.state.user && (
            <UserMenu
              user={this.state.user}
              hideDrawer={this.hideDrawer}
              openDrawer={this.openDrawer.bind(this)}
              isDrawerOpen={this.state.isDrawerOpen}
            />
          )}
        </Drawer>

        <main className={classes.content}>
          <Switch>
            <Route
              exact
              path="/"
              component={(props) => <Home {...props} user={this.state.user} />}
            />
            <Route
              exact
              path="/messages"
              component={(props) => (
                <Messages
                  {...props}
                  user={this.state.user}
                  getUnreadMessagesCount={this.getUnreadMessagesCount.bind(
                    this
                  )}
                />
              )}
            />

            <Route exact path="/carfin">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://carfin.xcars.kz"
                    : "https://test-carfin.xcars.kz"
                }
                ref={this.finbrokerFrameRef}
                id="carfin"
                token={this.state.token}
                updateTitle={() => this.updateTitle("CarFin")}
              />
            </Route>
            <Route exact path="/welcome">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://welcome.xcars.kz"
                    : "https://test-welcome.xcars.kz"
                }
                ref={this.welcomeFrameRef}
                id="welcome"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Цифровой путеводитель")}
              />
            </Route>
            <Route exact path="/valuation">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://valuation.xcars.kz/deals_list"
                    : "https://test-valuation.xcars.kz/deals_list"
                }
                //moduleURL = {'https://valuation.xcars.kz/deals_list'}
                ref={(e) => {
                  this.valuationFrameRef = e;
                }}
                id="valuation"
                token={this.state.token}
                updateTitle={() => this.updateTitle("АвтоВыкуп")}
              />
            </Route>
            <Route exact path="/oss">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://oss.xcars.kz"
                    : "https://test-oss.xcars.kz"
                }
                ref={this.valuationOssRef}
                id="oss"
                token={this.state.token}
                updateTitle={() => this.updateTitle("АвтоВыкуп")}
              />
            </Route>
            <Route exact path="/logist">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://logist.xcars.kz"
                    : "https://test-logist.xcars.kz"
                }
                ref={this.valuationLogistRef}
                id="logist"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Логист")}
              />
            </Route>
            <Route exact path="/buyer">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://buyer.xcars.kz"
                    : "https://test-buyer.xcars.kz"
                }
                ref={this.buyerFrameRef}
                id="buyer"
                token={this.state.token}
                updateTitle={() => this.updateTitle("АвтоВыкуп")}
              />
            </Route>
            <Route exact path="/pricer">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://valuation.xcars.kz/get_next_deal"
                    : "https://test-valuation.xcars.kz/get_next_deal"
                }
                //moduleURL = {'https://valuation.xcars.kz/get_next_deal'}
                ref={this.pricerFrameRef}
                id="pricer"
                token={this.state.token}
                updateTitle={() => this.updateTitle("АвтоВыкуп")}
              />
            </Route>
            <Route exact path="/inspector">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://inspector.xcars.kz"
                    : "https://test-inspector.xcars.kz"
                }
                ref={this.inspectorFrameRef}
                id="inspector"
                token={this.state.token}
                updateTitle={() => this.updateTitle("АвтоВыкуп")}
              />
            </Route>
            <Route exact path="/forensic">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://forensic.xcars.kz"
                    : "https://test-forensic.xcars.kz"
                }
                ref={this.crminalistFrameRef}
                id="forensic"
                token={this.state.token}
                updateTitle={() => this.updateTitle("АвтоВыкуп")}
              />
            </Route>
            <Route exact path="/ppp">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://ppp.xcars.kz"
                    : "https://test-ppp.xcars.kz"
                }
                ref={this.pppFrameRef}
                id="ppp"
                token={this.state.token}
                updateTitle={() => this.updateTitle("ППП")}
              />
            </Route>
            <Route exact path="/filter">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://filter.xcars.kz"
                    : "https://test-filter.xcars.kz"
                }
                ref={this.filterFrameRef}
                id="filter"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Фильтр")}
              />
            </Route>
            <Route exact path="/parser">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://parser.xcars.kz"
                    : "https://test-parser.xcars.kz"
                }
                ref={this.parserFrameRef}
                id="parser"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Парсер")}
              />
            </Route>
            <Route exact path="/adloader">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://adloader.xcars.kz"
                    : "https://test-adloader.xcars.kz"
                }
                ref={this.adloaderFrameRef}
                id="adloader"
                token={this.state.token}
                updateTitle={() => this.updateTitle("AdLoader")}
              />
            </Route>
            <Route exact path="/pp">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://pp.xcars.kz"
                    : "https://test-pp.xcars.kz"
                }
                ref={this.ppFrameRef}
                id="pp"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Печать ценников")}
              />
            </Route>
            <Route exact path="/user_admin">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://user-admin.xcars.kz"
                    : "https://test-user-admin.xcars.kz"
                }
                ref={this.authFrameRef}
                id="user_admin"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Админка")}
              />
            </Route>
            <Route exact path="/calendar">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://calendar.xcars.kz/calendar"
                    : "https://test-calendar.xcars.kz/calendar"
                }
                ref={this.calFrameRef}
                id="calendar"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Календарь")}
              />
            </Route>
            <Route exact path="/nps">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://nps-admin.xcars.kz"
                    : "https://test-nps-admin.xcars.kz"
                }
                frameRef={this.npsFrameRef}
                id="nps"
                token={this.state.token}
                updateTitle={() => this.updateTitle("MyClient")}
              />
            </Route>
            <Route exact path="/cars">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://car.xcars.kz"
                    : "https://test-car.xcars.kz"
                }
                frameRef={this.carFrameRef}
                id="cars"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Авто")}
              />
            </Route>
            <Route exact path="/clients">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://client.xcars.kz"
                    : "https://test-client.xcars.kz"
                }
                frameRef={this.clientFrameRef}
                id="clients"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Клиенты")}
              />
            </Route>
            <Route exact path="/mm">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://mm.xcars.kz"
                    : "https://test-mm.xcars.kz"
                }
                frameRef={this.mmFrameRef}
                id="mm"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Мобильный менеджер")}
              />
            </Route>
            <Route exact path="/sales">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://sales.xcars.kz"
                    : "https://test-sales.xcars.kz"
                }
                frameRef={this.salesFrameRef}
                id="sales"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Авто Продажа")}
              />
            </Route>
            <Route exact path="/keys">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://keys.xcars.kz"
                    : "https://test-keys.xcars.kz"
                }
                ref={this.keysFrameRef}
                id="keys"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Ключница")}
              />
            </Route>
            <Route exact path="/veditor">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://veditor.xcars.kz"
                    : "https://test-veditor.xcars.kz"
                }
                ref={this.veditorFrameRef}
                id="veditor"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Техсостояние авто")}
              />
            </Route>
            <Route exact path="/cc">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://cca.xcars.kz"
                    : "https://test-cca.xcars.kz"
                }
                ref={this.ccFrameRef}
                id="cc"
                token={this.state.token}
                updateTitle={() => this.updateTitle("КЦ")}
              />
            </Route>
            <Route exact path="/docs">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://docs.xcars.kz"
                    : "https://test-docs.xcars.kz"
                }
                ref={this.docsFrameRef}
                id="docs"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Инструкции")}
              />
            </Route>
            <Route exact path="/xxx">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://xxx.xcars.kz"
                    : "https://test-xxx.xcars.kz"
                }
                ref={this.xxxFrameRef}
                id="xxx"
                token={this.state.token}
                updateTitle={() => this.updateTitle("XXX")}
              />
            </Route>
            <Route exact path="/contracts">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://contracts-admin.xcars.kz"
                    : "https://test-contracts-admin.xcars.kz"
                }
                ref={this.contractsFrameRef}
                id="contracts"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Контракты")}
              />
            </Route>
            <Route exact path="/wiki">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://wiki-notion.xcars.kz"
                    : "https://test-wiki-notion.xcars.kz"
                }
                ref={this.wikiFrameRef}
                id="wiki"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Wiki")}
              />
            </Route>
            <Route exact path="/seo">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://seo.xcars.kz"
                    : "https://test-seo.xcars.kz"
                }
                ref={this.seoFrameRef}
                id="seo"
                token={this.state.token}
                updateTitle={() => this.updateTitle("СЭО")}
              />
            </Route>
            <Route exact path="/sadmin">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://sadmin.xcars.kz"
                    : "https://test-sadmin.xcars.kz"
                }
                ref={this.sadminFrameRef}
                id="sadmin"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Супер Админ")}
              />
            </Route>
            <Route exact path="/orionuseradmin">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://orion-user-admin-ui.xcars.kz"
                    : "https://test-orion-user-admin-ui.xcars.kz"
                }
                ref={this.orionUserAdminFrameRef}
                id="orionuseradmin"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Orion Админ")}
              />
            </Route>
            <Route exact path="/newcarsales">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://newcar-sales.xcars.kz"
                    : "https://test-newcar-sales.xcars.kz"
                }
                ref={this.newCarSalesFrameRef}
                id="newcarsales"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Продажи New")}
              />
            </Route>
            <Route exact path="/branch">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://branch.xcars.kz"
                    : "https://test-branch.xcars.kz"
                }
                ref={this.branchFrameRef}
                id="branch"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Салоны")}
              />
            </Route>
            <Route exact path="/edu-journal">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://edu-journal.xcars.kz"
                    : "https://test-edu-journal.xcars.kz"
                }
                ref={this.eduJournalFrameRef}
                id="edu-journal"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Журнал обучения")}
              />
            </Route>
            <Route exact path="/guarantee">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://guarantee.xcars.kz"
                    : "https://test-guarantee.xcars.kz"
                }
                ref={this.guaranteeJournalFrameRef}
                id="guarantee"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Гарантии")}
              />
            </Route>
            <Route exact path="/qr">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://qr.xcars.kz"
                    : "https://test-qr.xcars.kz"
                }
                ref={this.qrFrameRef}
                id="qr"
                token={this.state.token}
                updateTitle={() => this.updateTitle("QR")}
              />
            </Route>
            <Route exact path="/car-pricing">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://car-pricing.xcars.kz"
                    : "https://test-car-pricing.xcars.kz"
                }
                ref={this.carPricingFrameRef}
                id="car-pricing"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Ценообразование")}
              />
            </Route>
            <Route exact path="/bipiumx">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://bipiumx.xcars.kz"
                    : "https://test-bipiumx.xcars.kz"
                }
                ref={this.bipiumxFrameRef}
                id="bipiumx"
                token={this.state.token}
                updateTitle={() => this.updateTitle("BipiumX")}
              />
            </Route>
            <Route exact path="/arabax">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://arabax.xcars.kz"
                    : "https://test-arabax.xcars.kz"
                }
                ref={this.arabaxFrameRef}
                id="arabax"
                token={this.state.token}
                updateTitle={() => this.updateTitle("ArabaX")}
              />
            </Route>
            <Route exact path="/ppo">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://ppo.xcars.kz"
                    : "https://test-ppo.xcars.kz"
                }
                ref={this.ppoFrameRef}
                id="ppo"
                token={this.state.token}
                updateTitle={() => this.updateTitle("ППО")}
              />
            </Route>
            <Route exact path="/limits">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://limits.xcars.kz"
                    : "https://test-limits.xcars.kz"
                }
                ref={this.limitsFrameRef}
                id="limits"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Лимиты")}
              />
            </Route>
            <Route exact path="/support">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://support.xcars.kz"
                    : "https://test-support.xcars.kz"
                }
                ref={this.supportFrameRef}
                id="support"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Поддержка АХ")}
              />
            </Route>
            <Route exact path="/customer-support">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://customer-support.xcars.kz"
                    : "https://test-customer-support.xcars.kz"
                }
                ref={this.customerSupportFrameRef}
                id="customer-support"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Поддержка aster.kz")}
              />
            </Route>
            <Route exact path="/cp_pay">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://cp-payment.xcars.kz"
                    : "https://test-cp-payment.xcars.kz"
                }
                ref={this.cpPayFrameRef}
                id="cp_pay"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Оплата")}
              />
            </Route>
            <Route exact path="/news">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://news.xcars.kz"
                    : "https://test-news.xcars.kz"
                }
                ref={this.newsFrameRef}
                id="news"
                token={this.state.token}
                updateTitle={() => this.updateTitle("News")}
              />
            </Route>
            <Route exact path="/staff-list">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://staff-list.xcars.kz"
                    : "https://test-staff-list.xcars.kz"
                }
                ref={this.staffListFrameRef}
                id="staff-list"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Сотрудники")}
              />
            </Route>
            <Route exact path="/report_app_forms">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://app-form.xcars.kz"
                    : "https://test-app-form.xcars.kz"
                }
                ref={this.reportAppFormsFrameRef}
                id="report_app_forms"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Админка для отчетности")}
              />
            </Route>
            <Route exact path="/cs_contracts">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://cs-contracts.xcars.kz"
                    : "https://test-cs-contracts.xcars.kz"
                }
                ref={this.csContractsFrameRef}
                id="cs_contracts"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Контракты")}
              />
            </Route>
            <Route exact path="/binding">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://binding.xcars.kz"
                    : "https://test-binding.xcars.kz"
                }
                ref={this.bindingFrameRef}
                id="binding"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Привязка менеджеров")}
              />
            </Route>
            <Route exact path="/c2c">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://c2c.xcars.kz"
                    : "https://test-c2c.xcars.kz"
                }
                ref={this.c2cFrameRef}
                id="c2c"
                token={this.state.token}
                updateTitle={() => this.updateTitle("C2C Автокредит")}
              />
            </Route>
            <Route exact path="/new_auto_admin">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://new-auto-admin.xcars.kz/home"
                    : "https://test-new-auto-admin.xcars.kz/home"
                }
                ref={this.newAutoAdminFrameRef}
                id="newAutoAdmin"
                token={this.state.token}
                updateTitle={() =>
                  this.updateTitle("aster.kz Новые авто Админка")
                }
              />
            </Route>
            <Route exact path="/renewed_cs">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://renewed-cs.xcars.kz/home"
                    : "https://test-renewed-cs.xcars.kz/home"
                }
                ref={this.renewedCsFrameRef}
                id="renewedCs"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Продажа АМП v2")}
              />
            </Route>
            <Route exact path="/tires">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://tires.xcars.kz/home"
                    : "https://test-tires.xcars.kz/home"
                }
                ref={this.tiresFrameRef}
                id="tires"
                token={this.state.token}
                updateTitle={() => this.updateTitle("Шины АМП")}
              />
            </Route>
            <Route exact path="/security_qr">
              <ModuleContainer
                moduleURL={
                  window.location.hostname === "xcars.kz"
                    ? "https://security-qr.xcars.kz/home"
                    : "https://test-security-qr.xcars.kz/home"
                }
                ref={this.securityQrFrameRef}
                id="security-qr"
                token={this.state.token}
                updateTitle={() => this.updateTitle("QR СБ")}
              />
            </Route>
            <Route exact path="/credit_flow">
              <ModuleContainer
                  moduleURL={
                    window.location.hostname === "xcars.kz"
                        ? "https://credit-flow.xcars.kz/home"
                        : "https://test-credit-flow.xcars.kz/home"
                  }
                  ref={this.creditFlowFrameRef}
                  id="credit-flow"
                  token={this.state.token}
                  updateTitle={() => this.updateTitle("Кредитный конвейер")}
              />
            </Route>
            <Route exact path="/sign-docs">
              <ModuleContainer
                  moduleURL={
                    window.location.hostname === "xcars.kz"
                        ? "https://sign-docs.xcars.kz/home"
                        : "https://test-sign-docs.xcars.kz/home"
                  }
                  ref={this.signDocsFrameRef}
                  id="sign-docs"
                  token={this.state.token}
                  updateTitle={() => this.updateTitle("EDOCS")}
              />
            </Route>
            <Route exact path="/collection">
              <ModuleContainer
                  moduleURL={
                    window.location.hostname === "xcars.kz"
                        ? "https://collection.xcars.kz/home"
                        : "https://test-collection.xcars.kz/home"
                  }
                  ref={this.collectionFrameRef}
                  id="collection"
                  token={this.state.token}
                  updateTitle={() => this.updateTitle("COLLECTION")}
              />
            </Route>
            <Route exact path="/cession">
              <ModuleContainer
                  moduleURL={
                    window.location.hostname === "xcars.kz"
                        ? "https://cession.xcars.kz/home"
                        : "https://test-cession.xcars.kz/home"
                  }
                  ref={this.cessionFrameRef}
                  id="cession"
                  token={this.state.token}
                  updateTitle={() => this.updateTitle("Цессия")}
              />
            </Route>

            <Route
              exact
              path="/bi"
              render={(props) => (
                <ModuleContainer
                  {...props}
                  moduleURL={
                    props.location.state ? props.location.state.url : null
                  }
                  ref={this.xxxBIRef}
                  id="bi"
                  token={this.state.token}
                  updateTitle={() => this.updateTitle("BI")}
                />
              )}
            />
            <Route
              exact
              path="/bipiumx/cq/:id"
              render={(props) => (
                <ModuleContainer
                  {...props}
                  moduleURL={
                    props.location.state ? props.location.state.url : null
                  }
                  ref={this.bipiumxCqFrameRef}
                  id="bipiumxCq"
                  token={this.state.token}
                  updateTitle={() => this.updateTitle("BipiumX")}
                />
              )}
            />

            <Route exact path="/profile" component={Profile} />
            <Route exact path="/profile/calendar" component={CalendarPage} />
          </Switch>
        </main>

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          open={this.state.isNotificationSnackbarOpen}
          autoHideDuration={60000}
          onClose={() => this.setState({ isNotificationSnackbarOpen: false })}
          ContentProps={{ "aria-describedby": "message-id" }}
          message={<span id="message-id">Хотите получать уведомления?</span>}
          action={[
            <Button
              key="ok"
              color="primary"
              size="small"
              onClick={this.subscribeToNotifications.bind(this)}
            >
              Да
            </Button>,
            <Button
              key="no"
              color="secondary"
              size="small"
              onClick={() => {
                localStorage.setItem("blockNotifications", "1");
                this.setState({ isNotificationSnackbarOpen: false });
              }}
            >
              Нет
            </Button>,
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              className={classes.close}
              onClick={() =>
                this.setState({ isNotificationSnackbarOpen: false })
              }
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />

        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={this.state.isNoInternetSnackbarOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ isNoInternetSnackbarOpen: false })}
          ContentProps={{
            "aria-describedby": "message-id",
            style: { backgroundColor: "red" },
          }}
          message={<span id="message-id">Связь с Интернет прервана :(</span>}
          action={[]}
        />

        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={this.state.isInternetSnackbarOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ isInternetSnackbarOpen: false })}
          ContentProps={{
            "aria-describedby": "message-id",
            style: { backgroundColor: "green" },
          }}
          message={
            <span id="message-id">Связь с Интернет восстановлена! :)</span>
          }
          action={[]}
        />

        <Dialog
          open={this.state.hbdDialogVisible}
          onClose={() => this.setState({ hbdDialogVisible: false })}
        >
          <DialogTitle>С днем рождения!</DialogTitle>
          <DialogContent>
            <div>
              Дорогой {this.state.user && this.state.user.firstName}! 😊
              <p>Поздравляем тебя с днем рождения! 🥳🎂🎉 </p>Пусть сбываются
              твои мечты, все вокруг вдохновляет и приносит самые яркие эмоции!
              🤩 Желаем приятных путешествий, самых лучших людей на твоем пути и
              удовольствия от всего, что ты делаешь! 🎊 А AsterX пусть помогает
              тебе добиваться высоких показателей на работе! 🚀
              <p>C уважением, команда Феникс! ❤️</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({
                  hbdDialogVisible: false,
                });
                localStorage.setItem("hbdSeen", "yes");
              }}
            >
              Спасибо!
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);
